import { render, staticRenderFns } from "./ChatPlaceholder.vue?vue&type=template&id=c7efb464&scoped=true&"
import script from "./ChatPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ChatPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ChatPlaceholder.vue?vue&type=style&index=0&id=c7efb464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7efb464",
  null
  
)

export default component.exports